<h2 mat-dialog-title>Generate Pictures Report</h2>

<mat-dialog-content>
  <p class="step-header">1. Set Report Details</p>

  <div class="report-details-grid">
    <mat-form-field class="report-name-field" appearance="outline">
      <mat-label>Report Name*</mat-label>
      <input [(ngModel)]="reportName" (ngModelChange)="markUnsaved()" matInput />
    </mat-form-field>
  
    <label for="photosPerRowInput" class="visually-hidden">No. of photos per row</label>
    <mat-form-field class="photos-per-row-field" appearance="outline">
      <mat-label for="photosPerRowInput">No. of photos per row</mat-label>
      <input id="photosPerRowInput" [(ngModel)]="photosPerRow" matInput type="number" min="1" max="3"
        (change)="clampPhotosPerRow(); markUnsaved()" />
    </mat-form-field>
  
    <mat-form-field class="photo-labels-field" appearance="outline">
      <mat-label>Photo Labels/Tags on Report</mat-label>
      <mat-select [(ngModel)]="photoTagOption" (ngModelChange)="onPhotoTagOptionChange()">
        @for (option of photoTagsOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  
    <div class="orientation-container">
      <mat-form-field class="report-page-orientation-field" appearance="outline">
        <mat-label>Report Page Orientation</mat-label>
        <mat-select [(ngModel)]="selectedOrientation" (ngModelChange)="onPhotoOrientationOptionChange($event)">
          @for (option of photoOrientationOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-checkbox
        [(ngModel)]="numberedPictures"
        (ngModelChange)="markUnsaved()"
        [disabled]="isNumberedPicturesDisabled"
        color="primary"
        style="margin-left: 16px;">
        Numbered pictures
      </mat-checkbox>
    </div>
  </div>

  <div class="step-header-row">
    <span class="step-header">2. Add Sections and assign Pictures Tags</span>
    <button (click)="addSection()" mat-button color="primary">
      <mat-icon>add</mat-icon> ADD SECTION
    </button>
  </div>

  <div class="sections-list">
    @for (section of sections; track section.id) {
      <div class="section-card">
        <div class="section-header">
          @if (section.isEditing) {
            <input
              class="section-name-input"
              [(ngModel)]="section.name"
              (blur)="stopEditing(section)"
              (keydown.enter)="stopEditing(section)"
              (ngModelChange)="markUnsaved()"
              autofocus
            />
          } @else {
            <span class="section-title">{{ section.name }}</span>
          }
          <div class="section-actions">
            <mat-icon class="action-icon" (click)="editSection(section)" (keydown.enter)="editSection(section)" tabindex="0"
              >edit</mat-icon
            >
            <mat-icon class="action-icon" (click)="deleteSection(section)" (keydown.enter)="deleteSection(section)" tabindex="0"
              >delete</mat-icon
            >
            <mat-icon class="action-icon" (click)="duplicateSection(section)" (keydown.enter)="duplicateSection(section)" tabindex="0"
              >content_copy</mat-icon
            >            
            <mat-icon class="action-icon" (click)="toggleSection(section)" (keydown.enter)="toggleSection(section)" tabindex="0">
              {{ section.collapsed ? "expand_more" : "expand_less" }}
            </mat-icon>
          </div>
        </div>

        @if (!section.collapsed) {
          <div class="section-content">
            <mat-form-field class="tags-field">
              <mat-label>Add tags</mat-label>
              <mat-select [(ngModel)]="section.tags" (ngModelChange)="markUnsaved()" multiple>
                @for (tag of availableTags; track tag.id) {
                  <mat-option [value]="tag">{{ tag.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="saveTemplate()" mat-stroked-button color="primary" [disabled]="!canSaveTemplate">
    <mat-icon>save</mat-icon> SAVE TEMPLATE
  </button>
  @if (templateId) {
    <button (click)="deleteTemplate()" mat-button color="warn">DELETE</button>
  }
  <span class="spacer"></span>
  <button (click)="cancel()" mat-button>CANCEL</button>
  <button
    [disabled]="!canGenerate"
    (click)="generateReport()"
    mat-flat-button
    color="accent"
  >
    GENERATE REPORT
  </button>
</mat-dialog-actions>
